<template>
    <div>          
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label>Empresa</label>
                        <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                            @change="listarCentrosCustos"/>
                    </div>   
                    <div class="p-field p-col-12 p-md-6">                           
                        <div class="p-field-checkbox">
                            <Checkbox v-model="ativo" :binary="true"/>
                            <label>Ativo</label>
                        </div>
                    </div>                      
                </div>
            </div>
            <div class="p-col-12 p-md-6">
                <div class="p-fluid p-formgrid p-grid">                            
                    <div class="p-field p-col-9">
                        <label>Centro de custo</label>               
                        <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                            :filter="true" :showClear="true"/>
                    </div> 
                    <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Buscar" icon="pi pi-search" @click="listarPorFiltros()"/>
                    </div>   
                    <div class="p-field p-col-9 p-md-9">                        
                        <div class="p-inputgroup">
                            <InputText v-model.trim="crachaNome" 
                            @keyup.enter="listarPorFiltros()" 
                            @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')" 
                            placeholder="crachá/pis/cpf/nome"/>
                            <Button icon="pi pi-search" title="Buscar" @click="listarPorFiltros()"/>                    
                        </div>
                    </div>          
                </div>
            </div>
        </div>
        <DataTable :value="funcionarios" class="p-datatable-sm p-datatable-striped">
            <template #header>
                <div class="table-header">	
                    <Calendar v-model="dataInicio" :showIcon="true" 
                    :touchUI="true" :manualInput="false" 
                    dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>
                    <label class="p-ml-2 p-mr-2">Até</label>
                    <Calendar v-model="dataFinal" :showIcon="true" 
                    :touchUI="true" :manualInput="false" 
                    dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>
                </div>
            </template>
            <Column field="cracha" header="Crachá"></Column>
            <Column field="nome" header="Nome"></Column>
            <Column field="cargo" header="Cargo"></Column>
            <Column field="centroCusto" header="Centro de Custo"></Column>	
            <Column field="escala" header="Escala"></Column>	
            <Column field="dataCadastro" header="Cadastro"></Column>	
            <Column>
                <template #body="slotProps">
                    <Button icon="pi pi-download" title="Dowloado Comprovante" class="p-button-rounded p-button-primary p-mr-2"
                        @click="baixarComprovantes(slotProps.data)"/>						
                </template>
            </Column>
        </DataTable>
        <Paginacao ref="paginacao" :qtdLinhasPorPagina="[10,15,20,30]" :callback="listarPorPagina"/> 
    </div>
  </template>
  
  <script>
  import FuncionarioService from '@/service/FuncionarioService';
  import CentroCustoService from '@/service/CentroCustoService';
  import DocumentoService from '@/service/DocumentoService.js';
  import Paginacao from '@/components/template/Paginacao.vue';
  import CentroCusto from '@/model/CentroCusto';
  import { exibirMensagem, exibirMensagemSis, localeCalendarBR, download } from '@/global';
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
    documentoService: null,
    funcionarioService: null,
    centroCustoService: null,
    data() {
        return {             
            ativo: true,
            idCnpjSelecionado: null,
            cnpjs: [],
            idCentroCustoSelecionado: null,
            centrosCustos: [],
            crachaNome: '',
            funcionarios: [],
            filtro: {},
            qtdLinhasPorPagina: 10,
            numPagina: 1,
            rangeData: '',
            dataInicio: new Date(),
            dataFinal: new Date(),
            localeCalendarBR: localeCalendarBR        
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes','getCacheEmpresa']),
        ...mapActions('sessao', ['atualizarCacheEmpresa']),	          
        listarPorPagina(paginacao) {
            this.numPagina = paginacao.pagina;
            this.qtdLinhasPorPagina = paginacao.linhas;
            this.listar();
        },
        listarPorFiltros() {
            this.numPagina = 1;
            this.$refs.paginacao.paginar(1);
        },         
        listar() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let requisicao = {
                qtdLinhas: this.qtdLinhasPorPagina,
                numPagina: this.numPagina,
                crachaNome: this.crachaNome,
                ativo: this.ativo,
                idsCentrosCustos: idsCentrosCustos,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.funcionarioService.listar(requisicao)
            .then(resp => {                   
                this.$refs.paginacao.atualizar(resp.data.qdtFuncionarios);                       
                this.funcionarios = resp.data.funcionarios;
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },   
        listarCnpjs() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        listarCentrosCustos() {
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado; 
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {     
                // Cache dados      
                cacheEmpresa.centrosCustos = [];              
                resp.data.forEach(ct => {
                    cacheEmpresa.centrosCustos.push({...ct});
                });                   
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);   
                this.atualizarCacheEmpresa(cacheEmpresa);                      
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        baixarComprovantes(funcionario) {
            let requisicao = {
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                idFuncionario: funcionario.id,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };            
            this.documentoService.baixarComprovantes(requisicao)
            .then(resp => {                   
                download(resp.data, resp.headers['ik-response']);
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro);
            }); 
        },
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },
        formatarData(data) {
            if(!data) {
                return null;
            }
            let strData = null;
            if(data instanceof Date) {
                let dt = data;
                let mes = dt.getMonth();
                let dia = dt.getDate();
                strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
            } else {
                let partes = data.split('/');
                strData = partes[2] + '-' + partes[1] + '-' + partes[0];
            }
            return strData;
        },
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        }, 
    },	
    created() {
        this.documentoService = new DocumentoService();
        this.funcionarioService = new FuncionarioService();		
        this.centroCustoService = new CentroCustoService();		
    },
    mounted() {	
        this.listarCnpjs();			
    },
    components: {
        'Paginacao': Paginacao,
    }
}
</script>

<style>

</style>